let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e3PdM")).then(() => parcelRequire('awmCZ'));